// client/src/lib/mythicalDexNumbers.ts
//
// National-Pokédex numbers of the Mythical class.
//
// NOT a tradability list. This set was once used as a proxy for "cannot be
// traded, so can never be Lucky", and it drove the Lucky availability roster,
// the Lucky completion totals and the grid's "locked" badge. It was wrong in
// both directions — Meltan #808, Melmetal #809 and Pecharunt #1025 are tradable
// Mythicals, while Zygarde #718 and Eternatus #890 are untradable
// non-Mythicals — so every one of those callers now reads the GO Game
// Master's own isTradable flag instead (variantAvailability.isKnownUntradableSpecies,
// generated/tradableRoster.generated.ts).
//
// What remains is the plain Mythical taxonomy, mirroring legendaryDexNumbers.ts
// (which is Legendary-only and explicitly scopes Mythicals out) — the two sets
// are disjoint. Kept as a plain id list so it is trivial to extend as new
// Mythicals release.

export const MYTHICAL_DEX_NUMBERS: readonly number[] = [
  151, // Mew
  251, // Celebi
  385, // Jirachi
  386, // Deoxys
  489, // Phione
  490, // Manaphy
  491, // Darkrai
  492, // Shaymin
  493, // Arceus
  494, // Victini
  647, // Keldeo
  648, // Meloetta
  649, // Genesect
  719, // Diancie
  720, // Hoopa
  721, // Volcanion
  801, // Magearna
  802, // Marshadow
  807, // Zeraora
  808, // Meltan
  809, // Melmetal
  893, // Zarude
  1025, // Pecharunt
];

const MYTHICAL_SET = new Set<number>(MYTHICAL_DEX_NUMBERS);

/** True if the given national-dex number is a Mythical species. */
export function isMythicalDex(dexNumber: number): boolean {
  return MYTHICAL_SET.has(dexNumber);
}

